export const DEFAULT = 'default';
export const PSB = 'psb';
export const DIY = 'diy';

export const all = () => {
  return [
    {
      key: DEFAULT,
      value: 'Domyślny',
    },
    {
      key: PSB,
      value: 'PSB',
    },
    {
      key: DIY,
      value: 'DIY',
    },
  ];
};

